import { Plugin } from "prosemirror-state";

// Firefox caret issue workaround:
// https://github.com/ProseMirror/prosemirror/issues/1113
export const caretFixPlugin = () => {
    let focusing = false;
    return new Plugin({
        props: {
            handleDOMEvents: {
                focus: (view) => {
                    if (focusing) {
                        focusing = false;
                    } else {
                        focusing = true;
                        setTimeout(() => {
                            view.dom.blur();
                            view.dom.focus();
                        }, 0);
                    }
                    return false;
                },
            },
        },
    });
};
